import { call, take, put }   from 'redux-saga/effects';
import axios                 from 'axios';
import { SET_APPS }          from '../actions';
import mockApps              from '../utils/mockData/mockApps'

const endpoint = 'api/getApps.php';


function* getApps(): Generator<any,any,any> {
    while(true) {
      try {

        yield take('GET_APPS_SAGA');

        if (process.env.NODE_ENV === 'development') {
          yield put(SET_APPS(mockApps))
          return
        }
        
        const response = yield call( 
          axios.post, 
          endpoint
        )

        if (!response.data.success) {
            console.log(`couldn't get apps`)
        }
        else {
            console.log(JSON.stringify(response.data.result, null, 2))
            yield put(SET_APPS(response.data.result))
        }
      }
      catch (err) { console.log('err  :  '+err); }
      finally {}
    }
  }

export default getApps;


